const state = () => ({
  data: {},
  loading: false
});

const getters = {
  data(state) {
    return state.data;
  },
  loading(state) {
    return state.loading;
  }
};

const mutations = {
  setData(state, payload) {
    state.data = payload;
  },
  setLoading(state, payload) {
    state.loading = payload;
  }
};

const actions = {
  async loadData({ commit, dispatch }, { serviceType, serviceEntityId }) {
    commit('setLoading', true);

    let urlBase = '/v3/fe/';
    let updateEntityListActionName;

    switch (serviceType) {
      case 'question':
        urlBase += 'questions/';
        updateEntityListActionName = 'setQuestions';
        break;
      case 'appointment':
        urlBase += 'appointments/';
        updateEntityListActionName = 'setAppointments';
        break;
      default:
        break;
    }
    const url = `${urlBase}${serviceEntityId}`;

    await this.$http
      .get(url)
      .then(data => {
        if (data.aggregatedStatusName === 'QUESTION_INTERPRETATION_CREATED') {
          commit('setData', {
            ...data,
            statusBarButtonClick: () => {
              window.open(data.redirectLink, '_blank');
            }
          });
        } else {
          commit('setData', data);
        }

        if (updateEntityListActionName) {
          dispatch(`profile/dashboard/${updateEntityListActionName}`, null, { root: true });
        }
      })
      .catch(err => {
        dispatch('errorModal/handleError', { error: err, code: '0x0000005F' }, { root: true });
      })
      .finally(() => {
        commit('setLoading', false);
      });
  }
};

export const service = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
